import React, { useState, useEffect } from "react";
import ReactMarkdown from "react-markdown";
import PageHeader from "../ui/custom/page_header";
import TextContainer from "../ui/custom/text_container";
import DOMpurify from "dompurify";
import rehypeRaw from "rehype-raw";
import rehypeSmoothScroll from "../../utils/rehypeSmoothScroll";
import { useTranslation } from "../../TranslationContext";

const PrivacyPolicy = () => {
  const [markdown, setMarkdown] = useState("");
  const translations = useTranslation();
  const { privacyPolicy } = translations;

  useEffect(() => {
    fetch(privacyPolicy.markdownRoute)
      .then((response) => response.text())
      .then((text) => {
        const sanitizedMarkdown = DOMpurify.sanitize(text);
        setMarkdown(sanitizedMarkdown);
      })
      .catch((error) =>
        console.error("Error fetching privacy policy markdown:", error)
      );
  }, []);

  return (
    <div>
      <PageHeader title={privacyPolicy.pageTitle} />
      <TextContainer>
        <p className="markdown">
          <ReactMarkdown rehypePlugins={[rehypeRaw, rehypeSmoothScroll]}>
            {markdown}
          </ReactMarkdown>
        </p>
        <p className="pt-20 pb-2 uppercase font-semibold">
          {privacyPolicy.previousVersions.title}
        </p>
        <p className="m-0">
          <a
            href={privacyPolicy.previousVersions.currentVersion.url}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "underline" }}
          >
            {privacyPolicy.previousVersions.currentVersion.text}
          </a>
        </p>
      </TextContainer>
    </div>
  );
};

export default PrivacyPolicy;
